import pagesMenu from './menu.json'
import pagesMenu2 from './menu2.json'


function recursionPagesRouters (pagesMenu) {
  for (let item of pagesMenu) {
    if (item.src) {
      item.meta = Object.assign({}, item)
      item.component = resolve => require(['@/pages/' + item.src], resolve)
      pagesMenuRouters.push(item)
    } else if (item.children) {
      recursionPagesRouters(item.children)
    }
  }
}

let pagesMenuRouters = []
var pagesRouters = [
  {
    path: '/pages',
    component: resolve => require(['@/pages/main'], resolve),
    children: pagesMenuRouters
  }
]

export default function(user) {

  // localStorage.setItem('user', user.UserType)

  let menu = []
  let menuStr = sessionStorage.getItem('PAGE_MENU')
  if (user) {
    console.log("用户类型："+user.UserType)
    console.log("用户所属医院11："+user.hospital)
	console.log("用户所属医院集合："+user.hospitalList)
    localStorage.setItem('user', user.UserType)
	localStorage.setItem('userMobileSearch', user.Mobile)  
	localStorage.setItem('isRefresh', "1");
    if (user.UserType == 0) {//系统管理员
       menu = pagesMenu
			 console.log("pagesMenu==========")
      localStorage.setItem('userHospital', "admin")
	  
    } else if (user.UserType == 1) {//管理者
	menu = pagesMenu2
	if(user.hospitalList!=null&& user.hospitalList!=''){
		const strArr = user.hospitalList.split(',')
						console.log(strArr)
						if(strArr)
		
		localStorage.setItem('userHospital', strArr[0])
		localStorage.setItem('userSearchHospital', strArr[0])
		
	}else{
		localStorage.setItem('userHospital', "none")
		localStorage.setItem('userSearchHospital', '')
	}


      /* if (user.manageLevel == 0) {//助理
          menu = pagesMenu2
         localStorage.setItem('userHospital', user.hospitalNo)
       }else if (user.manageLevel == 1) { //护士长
          menu = pagesMenu2
         localStorage.setItem('userHospital', user.hospitalNo)
       }*/
    }
    sessionStorage.setItem('PAGE_MENU', JSON.stringify(menu))

  } else if (menuStr) {
    menu = JSON.parse(menuStr)

  }

  pagesMenuRouters = []
  recursionPagesRouters(menu)
  pagesRouters[0].children = pagesMenuRouters
  return pagesRouters
}



// WEBPACK FOOTER //
// ./src/router/pages/router.js